const setBodyOverflow = (overflow: 'auto' | 'hidden'): void => {
  document.body.style.overflow = overflow;
};

export default setBodyOverflow;
